import { GB } from '@mntn-dev/domain-types'

export const MaxFileSize = 5 * GB
